import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

export const postUserResponse = (params) => {
    const { body, pathsContext } = params;
    const fetchOptions = {
        method: 'POST',
        body
    };
    const url = `${pathsContext.serverUrl}/userresponses`;

    return (dispatch) =>
    VerbFetch(url, fetchOptions).then((response) => {
        let payload = {};
        body.map((userResponse, i) => {
                payload[userResponse.parentId] = {
                    _id: response[i]._id,
                    revision: response[i].revision
                };
            })
            dispatch({
                type: ACTIONS.POST_USER_RESPONSE,
                payload: {
                    userResponses: payload
                }
            });
            return payload;
        });
};

export const getUserResponse = (params) => {
    const { pathsContext, _id } = params;
    const url = `${pathsContext.serverUrl}/userresponses/${_id}`;
    const fetchOptions = {
        method: 'GET'
    };
    return VerbFetch(url, fetchOptions).then(body => body);
};

export const getManyUserResponses = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/userresponses`;
    const url = buildQueryString(rest, baseUrl);
    return VerbFetch(url);
};

export const putUserResponse = (params) => {
    const { body, pathsContext } = params;
    const [userResponse] = body;
    const { _id } = userResponse;
    const fetchOptions = {
        method: 'PUT',
        body: userResponse
    };
    const url = `${pathsContext.serverUrl}/userresponses/${_id}`;

    return (dispatch) =>
        VerbFetch(url, fetchOptions).then((body) => {
            dispatch({
                type: ACTIONS.PUT_USER_RESPONSE,
                payload: {
                    userResponses: body
                }
            });
            return body;
        });
};

export const putUserResponseStart = (params) => {
    const { body } = params;
    return (dispatch) =>
        dispatch({
            type: ACTIONS.PUT_USER_RESPONSE_START,
            payload: {
                userResponses: body
            }
        });
};
